import React from 'react';
import V5Shell from '../V5/V5Shell';

// V5Shell is the complete full-screen layout.
// It handles ALL screens internally — sidebar, header, routing, bottom bar.
export default function AppShell() {
  return <V5Shell />;
}
